import classNames from "classnames";

const Main = ({className, children}) => {
    return <main className={classNames('column', className)}>
        {children}
    </main>
}

export default Main;